export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-05_EN.054fa460.png";